function NonPartnerBookingPromotion() {
    function openNewTab() {
        window.open("https://www.pflegehilfe.org/mitglied-werden", "_blank");
    }

    return (
        <>
            <div className="lead-container">
                <h1 className="text-blue mb-50">Buchung</h1>
                <div className="booking-promotion-container">
                    <div className="Results-Headline">
                        Jetzt informieren und neue Kunden und Pflegepersonal
                        gewinnen.
                    </div>{" "}
                    <div className="promotion-container-body">
                        <div className="promotion-button">
                            <button
                                className="btn btn-info btn-medium"
                                onClick={openNewTab}
                            >
                                Informationen erhalten
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NonPartnerBookingPromotion;
